export default "__VITE_ASSET__Doy6Iam9__"